const lightenAndSaturate = (hex, lightAmount) => {
    hex = hex.replace('#', '');

    let r = parseInt(hex.substr(0, 2), 16);
    let g = parseInt(hex.substr(2, 2), 16);
    let b = parseInt(hex.substr(4, 2), 16);

    r = Math.round(r + (255 - r) * lightAmount);
    g = Math.round(g + (255 - g) * lightAmount);
    b = Math.round(b + (255 - b) * lightAmount);

    let avg = (r + g + b) / 3;
    r = Math.round(avg + (r - avg) * 1.2);
    g = Math.round(avg + (g - avg) * 1.2);
    b = Math.round(avg + (b - avg) * 1.2);

    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

const adjustBrightness = (hex, factor) => {
    hex = hex.replace('#', '');

    let r = parseInt(hex.substr(0, 2), 16);
    let g = parseInt(hex.substr(2, 2), 16);
    let b = parseInt(hex.substr(4, 2), 16);

    r = Math.round(r * factor);
    g = Math.round(g * factor);
    b = Math.round(b * factor);

    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

const hexToRgba = (hex, alpha) => {
    hex = hex.replace('#', '');

    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getColors = (color, whiteLabel) => {
    if (!color) color = '#526069';
    let secondaryBrand = null;
    let tertiaryBrand = null;
    let darkBrand = null;

    if (whiteLabel === 'latinad') {
        secondaryBrand = '#1023F6';
        tertiaryBrand = '#3BEBFF';
        darkBrand = '#07113C';
    } else if (whiteLabel === 'blaster') {
        secondaryBrand = '#d7ee28';
        tertiaryBrand = adjustBrightness(secondaryBrand, 0.8);
        darkBrand = adjustBrightness(color, 0.5);
    }

    const secondary = secondaryBrand || adjustBrightness(color, 0.5);
    const tertiary = tertiaryBrand || adjustBrightness(color, 0.8);
    const dark = darkBrand || adjustBrightness(color, 0.2);

    return {
        primary: color,
        secondary: secondary,
        tertiary: tertiary,
        dark: dark,
        primaryLight: lightenAndSaturate(color, 0.4),
        secondaryLight: lightenAndSaturate(secondary, 0.4),
        tertiaryLight: hexToRgba(tertiary, 0.3),
        translucent: hexToRgba(color, 0.2),
    }
}

export const darkenAndSaturate = (hex, darkAmount, saturateAmount) => {
    hex = hex.replace('#', '');

    let r = parseInt(hex.substr(0, 2), 16);
    let g = parseInt(hex.substr(2, 2), 16);
    let b = parseInt(hex.substr(4, 2), 16);

    r = Math.round(r * (1 - darkAmount));
    g = Math.round(g * (1 - darkAmount));
    b = Math.round(b * (1 - darkAmount));

    let avg = (r + g + b) / 3;
    r = Math.round(avg + (r - avg) * saturateAmount);
    g = Math.round(avg + (g - avg) * saturateAmount);
    b = Math.round(avg + (b - avg) * saturateAmount);

    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
// Shifts a hex color in HSL space: hue is added in degrees, saturation and
// lightness are multiplied (1 = unchanged). Returns an uppercase hex.
export const shiftHsl = (hex, { hue = 0, saturation = 1, lightness = 1 }) => {
    hex = hex.replace('#', '');

    const r = parseInt(hex.substr(0, 2), 16) / 255;
    const g = parseInt(hex.substr(2, 2), 16) / 255;
    const b = parseInt(hex.substr(4, 2), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const d = max - min;
    let l = (max + min) / 2;
    let s = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
    let h = !d ? 0 : max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;

    h = (((h * 60 + hue) % 360) + 360) % 360;
    s = Math.max(0, Math.min(1, s * saturation));
    l = Math.max(0, Math.min(1, l * lightness));

    const a = s * Math.min(l, 1 - l);
    const channel = (n) => {
        const k = (n + h / 30) % 12;
        return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))));
    };

    return '#' + [channel(0), channel(8), channel(4)].map((v) => v.toString(16).padStart(2, '0')).join('').toUpperCase();
};
